<template>
  <div id="filter-result-app" @scroll="onScroll" :class="(view == 'list') ? 'view-list' : 'view-grid'">
    <v-container v-if="this.$route.params.name && isMobile()">
      <v-row justify="center" align="center">
        <v-col :cols="colsMobile">
          <div class="dealer-container-mobile">
            <span class="favorite" :id="'fav-' + advertiser.company.id">
              <Heart @click="handleUnFavorite(advertiser.company.id)" color="#ee2424" :size="22" fill="#ee2424" v-if="isFavorite"/>
              <Heart @click="handleFavorite(advertiser.company.id)" color="#313131" :size="22" v-else />
            </span>
            <v-img :src="advertiser.company.logo_empresa" :alt="`Logo de ${advertiser.company.nome_fantasia_empresa}`" cover
                 style="border-radius: 4px;" width="100%" height="100" />
            <div @click="videoDialog = true" class="video-overlay-button" v-show="advertiser.company.video">
              <v-icon small class="mr-1">mdi-play-circle</v-icon>
              VÍDEO
            </div>
          </div>
        </v-col>
        <v-col :cols="colsMobile">
          <div class="d-flex flex-column justify-start align-start position-relative">
            <small class="grupo-style text-black">Grupo</small>
            <h6 class="anunciante">{{ advertiser.company.nome_fantasia_empresa.toUpperCase() }}</h6>
            <div v-if="rating !== '0' && rating !== undefined" class="d-flex align-start flex-column" style="cursor: pointer;"
                 @click="toggleDropdown">
              <div class="d-flex align-baseline mt-2">

                <v-rating size="20" :model-value="rating" half-increments readonly color="amber" bg-color="grey-lighten-2"
                          density="compact" class="mr-2" />
                <span class="mr-1 font-weight-medium text-amber font-bold" style="font-size: 20px">{{ rating }}</span>


                <v-icon size="18" class="text-amber font-bold">
                  {{ showDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <div v-if="showDetails" class="d-flex flex-column">
            <v-row dense no-gutters class="flex-column" style="font-size: 9pt">
              <v-col v-for="(item, index) in detalhes" :key="index" class="d-flex flex-column align-start">
                <div class="d-flex">
                  <v-rating :model-value="item.score" half-increments readonly color="grey-darken-1"
                    bg-color="grey-darken-1" density="compact" size="15" class="me-2" />
                  <span class="text-body-2 text-grey-darken-1 font-weight-regular mr-1">
                    {{ item.score }}
                  </span>
                  <span class="text-body-2 text-grey-darken-1 font-weight-regular mr-1">
                    {{ item.detail }}
                  </span>
                </div>
              </v-col>
              <v-col>
                <span class="text-caption text-grey-lighten-1">
                  ({{ reviews }} reviews de {{ clientes }} clientes)
                </span>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>

      <v-dialog v-if="advertiser.company.video" v-model="videoDialog" max-width="900px" persistent scrollable
        :scrim="'rgba(0, 0, 0, 0.85)'">
        <v-card class="bg-black pa-0">
          <v-card-text class="pa-0">
            <iframe :src="youtubeEmbedUrl" width="100%" height="500" frameborder="0" allowfullscreen></iframe>
          </v-card-text>
        </v-card>

        <v-btn icon class="video-close-btn" @click="videoDialog = false">
          <v-icon size="32" color="white">mdi-close</v-icon>
        </v-btn>
      </v-dialog>
    </v-container>

    <v-container v-if="vehicleLoading && selectedPage <= 1" fluid>
      <LoadingItems :loading="loading" :selectedPage="selectedPage" :totalPages="totalPages" />
      <v-row v-if="!isMobile()">
        <v-col
          v-for="(_, index) in Array.from(Array(8).keys())"
          v-bind:key="index"
          class="mx-auto"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="3"
          xxl="3"
        >
          <v-skeleton-loader class="mx-auto border card-skeleton" type="image, article, actions"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col v-for="(_, index) in Array.from(Array(8).keys())" v-bind:key="index" cols="12">
          <v-skeleton-loader class="mx-auto border card-skeleton" type="article, actions"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
    <div v-else>
      <v-container class="container-not-result not-result pl-6" v-if="vehicles.length === 0 && !isMobile()">
        <v-row>
          <v-col>
            <span class="sorry-text">
              {{ textSorryNotResult }}
            </span>
          </v-col>
        </v-row>
      </v-container>

      <div v-else-if="vehicles.length === 0 && isMobile()" class="pa-6">
        <span class="sorry-text"> {{ textSorryNotResult }} </span><br />
      </div>

      <v-container v-if="vehicles.length > 0 && !isMobile()" v-bind:key="vehicles.length" fluid>
        <v-row v-show="view === 'grid'">
          <v-col
            v-for="(vehicle, index) in vehicles"
            v-bind:key="vehicle.id_avaliacao"
            v-bind:index="index"
            class="mx-auto"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            xl="3"
            xxl="3"
          >
            <VehicleItem :vehicle="vehicle" :index="index" :linha="index" />
          </v-col>
        </v-row>
        <v-row v-show="view === 'list'">
          <v-col v-for="(vehicle, index) in vehicles" v-bind:key="vehicle.id_avaliacao" v-bind:index="index" sm="12"
            md="12" lg="12" xl="12" xxl="6">
            <VehicleItem view="list" :vehicle="vehicle" :index="index" :linha="index" />
          </v-col>
        </v-row>
      </v-container>
      <div v-else-if="vehicles.length > 0 && isMobile()">
        <div v-for="(vehicle, index) in vehicles" v-bind:key="vehicle.id_avaliacao">
          <VehicleItem :vehicle="vehicle" :index="index" :linha="index" />
        </div>
      </div>
    </div>
    <LoadingItems :loading="loading" :selectedPage="selectedPage" :totalPages="totalPages" />
    <v-spacer style="height: 100px;" v-if="!loading && selectedPage >= totalPages && vehicles.length > 0" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { VSkeletonLoader } from "vuetify/components";
import {
  favoriteDealer,
  unFavoriteDealer
} from "@/services/api/DealerServiceApi";
import VehicleItem from "@/components/VehicleItem/index.vue";
import PlatformsMixins from "@/mixins/PlatformsMixins";
import LoadingItems from "@/components/LoadingItems.vue";
import { Heart } from "lucide-vue-next";
import { useDisplay } from "vuetify";
import {toTitleCase} from "@/helpers/strings";

export default {
  name: "FilterResultApp",
  components: {
    VehicleItem,
    VSkeletonLoader,
    LoadingItems,
    Heart,
  },
  mixins: [PlatformsMixins],
  data() {
    return {
      fantasia: '',
      videoDialog: false,
      showDetails: false,
      isFavorite: false,
      page: 1,
      textSorryNotResult:
        "Desculpe! No momento, não há veículos com essas características...",
      textAlertNotResult:
        "→ Seja avisado quando este veículo estiver disponível!",
      textAlertButtonNotResult: "Criar alerta de veículo",
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.filterForm.vehicleLoading,
      detalhes: state => state.advertiser.list?.company?.details_reviews || [],
      reviews: state => state.advertiser.list?.company?.total_reviews || 0,
      clientes: state => state.advertiser.list?.company?.total_customers_reviews || 0,
      vehicleLoading: (state) => state.filterForm.vehicleLoading,
      vehicles: (state) => state.filterForm.result,
      selectedPage: (state) => state.filterForm.page,
      totalPages: (state) => state.filterForm.total,
      params: (state) => state.filterForm.params,
      ads: (state) => state.ads,
      view: (state) => state.global.view,
    }),

    ...mapState("advertiser", {
      advertiser: (state) => state.list,
      rating: (state) => state.list.company.nota_reviews,
    }),

    youtubeEmbedUrl() {
      try {
        const url = new URL(this.advertiser.company.video);
        const videoId = url.searchParams.get('v') || url.pathname.split('/').pop();
        return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : '';
      } catch {
        return '';
      }
    },
    colsMobile() {
      const { width } = useDisplay();
      return (width.value < 400) ? 12 : 6;
    }
  },
  methods: {
    ...mapActions("filterForm", ["pagination"]),
    ...mapActions("ads", ["getCampaign"]),
    ...mapMutations('global', ['setRouteParams', 'setCurrentMainMenu']),
    handlePaginate(page) {
      this.pagination(page);
    },
    toggleDropdown() {
      this.showDetails = !this.showDetails;
    },
    async handleFavorite(id) {
      this.isFavorite = true;
      try {
        await favoriteDealer(id)
      } catch (error) {
        this.isFavorite = false
      }
    },
    async handleUnFavorite(id) {
      this.isFavorite = false;
      try {
        await unFavoriteDealer(id)
      } catch (error) {
        this.isFavorite = true
      }
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      const reachedTheEndOfThePage = Math.round(scrollTop + clientHeight) + 1 >= scrollHeight;
      if (reachedTheEndOfThePage) {
        if (!this.vehicleLoading) {
          const isTheLastPage = this.selectedPage + 1 > this.totalPages;
          if (isTheLastPage) {
            return;
          }
          this.handlePaginate(this.selectedPage + 1);
        }
      }
    },
    onResize() {
      const reachedTheEndOfThePage = parseInt(this.contentHeightWithButtonFooter) > document.querySelector("#filter-result-app .v-container").clientHeight;
      if (reachedTheEndOfThePage) {
        if (!this.loading) {
          const isTheLastPage = this.selectedPage + 1 > this.totalPages;
          if (isTheLastPage) {
            return;
          }
          this.handlePaginate(this.selectedPage + 1);
        }
      }
    }
  },
  mounted: function () {
    this.page = this.selectedPage;

    if (!this.isMobile()) {
      window.addEventListener('resize', this.onResize);
    }

    this.fantasia = this.$route.params.name;
    this.$store.dispatch("advertiser/getAdvertiser", this.fantasia).then(() => {
      if (this.advertiser && this.advertiser.dealers && this.advertiser.dealers.length > 0) {
        this.isFavorite = (this.advertiser.dealers[0].favorita == 1);
      }
      if (this.advertiser?.company?.nome_fantasia_empresa) {
        this.setCurrentMainMenu({
          section: "dealers",
          breadcrumb: ["Veículos", toTitleCase(this.advertiser?.company?.nome_fantasia_empresa)],
          filter: false,
          order: true,
        });
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  }
};
</script>

<style scoped>
.video-close-btn {
  position: fixed;
  top: 20px;
  right: 30px;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.5);
}

.grupo-style {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.anunciante {
  color: black;
  font-size: 18px;
  font-weight: 400;
  font-family: "Roboto", Roboto, Helvetica, sans-serif;
  text-shadow: 0 1px 1px #000;
  line-height: 24px;
  font-weight: bold;
}

.video-overlay-button {
  position: absolute;
  bottom: 10px;
  background-color: red;
  color: white;
  font-weight: bold;
  font-size: 11px;
  border-radius: 4px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}

.container-alert-text-vehicle {
  display: flex;
  justify-content: flex-start;
}

.card-skeleton {
  border: 7px solid #ffffff;
  border-radius: 12px;
}

.alert-text-vehicle {
  color: #868686;
  font-size: 18px;
  font-family: "Lexend Deca";
  font-weight: 400;
  word-wrap: break-word;
  width: 500px;
  line-height: 40px;
}

.sorry-text {
  color: #868686;
  font-size: 22px;
  font-family: "Lexend Deca";
  font-weight: 400;
  word-wrap: break-word;
}

.favorite {
  position: absolute;
  top: 10px;
  left: 15px;
  cursor: pointer;
  z-index: 999;
}

.btn-alert-vehicle {
  color: white;
  font-size: 18px !important;
  font-family: "Lexend Deca";
  font-weight: 400;
  word-wrap: break-word;
  width: 260px !important;
  background-color: #ff7a00 !important;
}

#filter-result-app {
  flex: 78;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 25px;
  height: v-bind(contentHeightWithButtonFooter);
}

@media screen and (max-width: 768px) {
  #filter-result {
    position: relative;
  }

  #filter-result-app {
    padding: 0px;
    width: 100%;
  }

  .container-not-result {
    padding: 15px;
  }

  .not-result {
    min-height: 65vh !important;
  }
}

.not-result {
  position: relative;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
}

.dealer-container-mobile {
  position: relative;
  width: 180px;
  height: 100px;
  padding: 4px;
}
</style>
